//console.log("cart-opener.js loaded");
const nextOpenValue = 2000 // This is in cents

// check if session sotrage is supported
if (typeof Storage !== "undefined") {
    // check if variable lastOpenValue exists in session storage
    if (sessionStorage.getItem("lastOpenValue") === null) {
        // if not, set it to 0
        sessionStorage.setItem("lastOpenValue", "0");
    }
} else {
  console.log("Sorry! No Web Storage support..");
}


function checkCartValue() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartValue = cart.total_price // This is in cents
      // get lastOpenValue from session storage and convert to number
        const lastOpenValue = Number(sessionStorage.getItem("lastOpenValue"));
      const openAt = lastOpenValue + nextOpenValue;

      //debugging
        // console.log("cartValue: " + cartValue);
        // console.log("lastOpenValue: " + lastOpenValue);
        // console.log("nextOpenValue: " + nextOpenValue);
        // console.log("openAt: " + openAt);
        // console.log("cartValue > lastOpenValue + nextOpenValue: " + (cartValue > openAt));

      if (lastOpenValue != null && cartValue > openAt) {
        // open cart and set lastOpenValue to current cart value
        openCart()
        sessionStorage.setItem("lastOpenValue", cartValue);
      }
    })
}

function openCart(){
    const interval = setInterval(() => {
        const cartDrawerOpen = document.querySelector("html.cart-drawer--open")
        const openCartButton = document.querySelector(".header__cart-toggle")

        if (openCartButton != undefined) {
        openCartButton.click()
        }

        if (cartDrawerOpen) {
        clearInterval(interval)
        }
    }, 100)
}

// If you want to check the cart value every time an item is added to the cart,
// you can listen for the 'cart:refresh' event, which is fired by Shopify's AJAX API
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButtons = document.querySelectorAll(".product-item__action-button, .product-form__add-button") 

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Wait a bit for the item to be added to the cart before checking the cart value
      setTimeout(checkCartValue, 800)
    })
  })
})
